// 订单设置
<template>
  <div class="Tape">
    <el-row>
      <el-col :span="6">
        <tapeDetail></tapeDetail>
      </el-col>
      <el-col :span="18">
        <tapeTabel></tapeTabel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import tapeDetail from './components/tape-detail.vue';
import tapeTabel from './components/tape-tabel.vue';

export default {
  name: 'Tape',
  components: {
    tapeDetail,
    tapeTabel,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.Tape {
  overflow: hidden;
  background: #fff;
}
</style>
